var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStruersEmblem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v13.385c0 3.227 1.142 6.34 3.214 8.696 2.942 3.345 7.022 5.244 8.782 5.657h.009c1.76-.413 5.84-2.31 8.782-5.657 2.072-2.357 3.214-5.47 3.214-8.696V0H0z",
    fill: "#95A3AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.292 5.509L3.445 19.107H6.89l6.818-13.6-3.415.002zM16.288 2.104L9.44 15.702l3.443.002 6.818-13.6h-3.413zM17.143 8.936l-6.848 13.599 3.443.001 6.818-13.6h-3.413z",
    fill: "#fff"
  })));
}
export default SvgIconStruersEmblem;